import { PORTAL_ONBOARDING_PHASE } from '../portal-onboarding.const'

import type { PortalOnboardingStoreState } from './portal-onboarding.type'

export const portalOnboardingInitialState: PortalOnboardingStoreState = {
  phase: PORTAL_ONBOARDING_PHASE.idle,
  currentStepIndex: 0,
}
